module.exports = __webpack_public_path__ + "static/media/betyaros-adatkezelesi-tajekoztato.e6a89790.pdf";